export default "__VITE_ASSET__DgWOy7Pc__"